import { render, staticRenderFns } from "./TicketPasteAttacmentPreview.vue?vue&type=template&id=b06ca9ca&scoped=true&"
import script from "./TicketPasteAttacmentPreview.vue?vue&type=script&lang=ts&"
export * from "./TicketPasteAttacmentPreview.vue?vue&type=script&lang=ts&"
import style0 from "./TicketPasteAttacmentPreview.vue?vue&type=style&index=0&id=b06ca9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06ca9ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b06ca9ca')) {
      api.createRecord('b06ca9ca', component.options)
    } else {
      api.reload('b06ca9ca', component.options)
    }
    module.hot.accept("./TicketPasteAttacmentPreview.vue?vue&type=template&id=b06ca9ca&scoped=true&", function () {
      api.rerender('b06ca9ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketPasteAttacmentPreview.vue"
export default component.exports